import { render } from "./Mutant.vue?vue&type=template&id=84fc36c8&scoped=true"
import script from "./Mutant.vue?vue&type=script&lang=js"
export * from "./Mutant.vue?vue&type=script&lang=js"

import "./Mutant.vue?vue&type=style&index=0&id=84fc36c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84fc36c8"]])

export default __exports__